// Standard filter values for loan properties

export const PROPERTY_SECTORS = [
  'Multifamily',
  'Office',
  'Retail',
  'Industrial',
  'Hotel',
  'Other',
] as const;

export const LOAN_STATUSES = [
  'Performing',
  '30–59 Days Delinquent',
  '60–89 Days Delinquent',
  '90+ Days Delinquent',
  'Default',
  'Foreclosure',
  'REO',
  'Forbearance',
] as const;

export const INTEREST_TYPES = ['Fixed', 'Floating'] as const;

export const AMORTIZATION_TYPES = [
  'Amortizing',
  'Interest Only',
  'Partial IO',
  'Balloon',
] as const;

export const POSITION_IN_CAPITAL_STACK = [
  'Senior',
  'Mezzanine',
  'Subordinate',
  'Preferred Equity',
] as const;

export const PROPERTY_LIFECYCLE_FINANCING = [
  'Permanent',
  'Construction',
  'Bridge',
  'Refinance',
  'Transitional',
] as const;

export const CURRENCIES = ['USD', 'EUR', 'GBP'] as const;

// Type exports
export type PropertySector = (typeof PROPERTY_SECTORS)[number];
export type LoanStatus = (typeof LOAN_STATUSES)[number];
export type InterestType = (typeof INTEREST_TYPES)[number];
export type AmortizationType = (typeof AMORTIZATION_TYPES)[number];
export type PositionInCapitalStack = (typeof POSITION_IN_CAPITAL_STACK)[number];
export type PropertyLifecycleFinancing =
  (typeof PROPERTY_LIFECYCLE_FINANCING)[number];
export type Currency = (typeof CURRENCIES)[number];
